export const http = { BASE_URL: process.env.REACT_APP_DB_URL };
